import React from 'react';
import PageWrapper from '../../components/UI/PageWrapper';
import TeamDetails from '../../components/Admin/TeamDetails';

const TeamDetailsPage = () => (
  <PageWrapper>
    <TeamDetails />
  </PageWrapper>
);

export default TeamDetailsPage;

